import { Draggable } from 'react-beautiful-dnd';
import { Question } from 'api/questions/types';
import { ExamQuestionRow } from './ExamQuestionRow';

interface Props {
  sectionId: number;
  blockIndex: number;
  question: Question;
  qInBlock: number;
  sectionQuestions: Question[];
  sIndex: number;
  onEdit: (q: Question) => void;
  onDelete: (sIndex: number, questionId: string) => void;
}

export function ExamScenarioQuestionRow({
  sectionId,
  blockIndex,
  question,
  qInBlock,
  sectionQuestions,
  sIndex,
  onEdit,
  onDelete
}: Props) {
  const foundIndex = sectionQuestions.findIndex((qq) => qq._id === question._id);
  const displayIndex = foundIndex >= 0 ? foundIndex + 1 : blockIndex + qInBlock + 1;

  return (
    <Draggable
      key={question._id}
      draggableId={`blockq-${sectionId}-${blockIndex}-${question._id}`}
      index={qInBlock}
    >
      {(providedQ) => {
        const { style: rbdStyle, ...restDraggableProps } = providedQ.draggableProps;
        return (
          <li
            ref={providedQ.innerRef}
            className="grid items-center gap-2 w-full border-l-2 border-tertiary pl-2"
            style={{
              ...rbdStyle,
              display: 'grid',
              gridTemplateColumns: '1fr auto'
            }}
            {...restDraggableProps}
          >
            <ExamQuestionRow
              question={question}
              displayIndex={displayIndex}
              dragHandleProps={providedQ.dragHandleProps}
              onEdit={onEdit}
              onDelete={() => onDelete(sIndex, question._id)}
            />
          </li>
        );
      }}
    </Draggable>
  );
}
